import { observer, use$ } from '@legendapp/state/react';
import {
  Button,
  type ButtonProps,
  type PolymorphicComponentProps,
  Stack,
  Text,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useStartManualBet } from '../../../hooks';
import { configurationState$, manualBetState$ } from '../../../state';
export type MobileManualBetStartButtonProps = PolymorphicComponentProps<
  'button',
  ButtonProps
>;

export const MobileManualBetStartButton = observer(
  (props: MobileManualBetStartButtonProps) => {
    const isBetting = use$(manualBetState$.isBetting);
    const betAmount = use$(manualBetState$.betAmount);
    const currency = use$(configurationState$.currency);
    const { t } = useTranslation();

    const {
      handleStartManualBet,
      mutation: { isPending },
    } = useStartManualBet();

    if (isBetting) {
      return null;
    }

    return (
      <Button
        data-test-id="mobile-manual-bet-start-button"
        disabled={isPending}
        fullWidth
        hidden={isBetting}
        onClick={handleStartManualBet}
        size="lg"
        {...props}
      >
        <Stack gap={2}>
          <Text component="span" fw={600} inline size="xs">
            {t('manualBet.start')}
          </Text>
          <Text component="span" inline size="xs">
            {betAmount.toFixed(2)} {currency}
          </Text>
        </Stack>
      </Button>
    );
  }
);
